import { ProductDataSubscriptionGroup } from '@barracuda-internal/bds-core-v2'
import { cloneDeep } from 'lodash'

import { config } from 'global/lib/config'
import { setAccountSubscriptionData } from 'global/redux/features/account/accountSlice'

// We only mock IP and IR products for the demo account
const mockDemoAccProductData = {
  subscriptionGroups: [
    {
      id: 'EMAIL_PROTECTION_PREMIUM_PLUS',
      isBundle: true,
      bundle: {
        id: 'EMAIL_PROTECTION_PREMIUM_PLUS',
        name: 'Email Protection Premium Plus'
      },
      subscriptions: [
        {
          id: 'FUcBtGjJ64MmFlnGA4pWp',
          status: 'ACTIVE',
          isProductOfInterest: true,
          productRequestStatus: 'SUCCESS',
          firstValueStatus: 'Unknown',
          serial: null,
          product: {
            id: '20',
            name: 'Impersonation Protection',
            category: 'EMAIL_PROTECTION',
            appUrls: {
              main: config.domains.sentinel
            },
            uxOptions: {
              showInNavigation: true,
              msAdminRequired: true,
              openInNewTab: false
            }
          },
          isTrial: true,
          isNavigable: true,
          isExpired: false
        },
        {
          id: 'q2vIc6fomd2Ti6pEp1M5Z',
          status: 'ACTIVE',
          isProductOfInterest: false,
          productRequestStatus: 'SUCCESS',
          firstValueStatus: 'Unknown',
          serial: null,
          product: {
            id: '25',
            name: 'Incident Response',
            category: 'EMAIL_PROTECTION',
            appUrls: {
              main: config.domains.forensics
            },
            uxOptions: {
              showInNavigation: true,
              msAdminRequired: true,
              openInNewTab: false
            }
          },
          isTrial: true,
          isNavigable: true,
          isExpired: false
        }
      ]
    }
  ],
  pendingActivations: []
}

export default function updateMockDemoUrlData(accessTokenId: string, dispatch: (action: any) => void) {
  // Have to deep clone the mock data to avoid mutating the original object error
  const mockedDemoAccData = cloneDeep(mockDemoAccProductData.subscriptionGroups) as ProductDataSubscriptionGroup[]
  mockedDemoAccData.forEach(subscriptionGroup =>
    subscriptionGroup.subscriptions.forEach(subscription => {
      switch (subscription.product.id) {
        case config.PRODUCTS.IDS.FORENSICS.toString():
          // eslint-disable-next-line no-param-reassign
          subscription.product.appUrls.main = accessTokenId
            ? `${config.domains.forensics}/report/${accessTokenId}/remediation`
            : subscription.product.appUrls.main
          break
        case config.PRODUCTS.IDS.SENTINEL.toString():
          // eslint-disable-next-line no-param-reassign
          subscription.product.appUrls.main = accessTokenId
            ? `${config.domains.sentinel}/report/${accessTokenId}/dashboard`
            : subscription.product.appUrls.main
          break
        default:
          break
      }
    })
  )
  dispatch(setAccountSubscriptionData(mockedDemoAccData))
}
